const __request = require(`yinzhilv-js-sdk/frontend/common-project/lib/data-service/default/__request/__request_contentType_form`);
const redirect_to_login_page = require(`@/lib/common-service/redirect_to_login_page`).default;
const __request_contentType_form = function (pParameter) {
  if (!pParameter) pParameter = {};
  pParameter.appKey = `flight`;
  pParameter.redirect_to_login_page = redirect_to_login_page;
  return __request(pParameter);
};
module.exports = __request_contentType_form;
